import { Heading, Paragraph } from "@/components/ui/Typography";
import { sanitizeHtml } from "@/utils/helpers/html";

const TimelineItem = ({data, brandingData}:{data?: {
  missionTimeLineSectionTitle?: string;
  missionTimeLineSectionDescription?: string;
  missionTimeLineSectionImageUrl?: string | null;
  missionTimeLineStartDate?: string;
  missionTimeLineEndDate?: string;
}; brandingData?: { websiteColorCode?: string } }) => {

 

  const PreviewComponent = () => {
    return (
      <div className="flex relative flex-col w-full  gap-2  justify-center" >   

          <div className="flex items-center gap-3">
            <Paragraph style={{color: brandingData?.websiteColorCode }} className="uppercase">{data?.missionTimeLineStartDate}-{data?.missionTimeLineEndDate}</Paragraph>
          
          </div>
          <Heading level={3}>{data?.missionTimeLineSectionTitle}</Heading>
          <Paragraph dangerouslySetInnerHTML={{ __html: sanitizeHtml(data?.missionTimeLineSectionDescription ?? "") }} ></Paragraph>
         {data?.missionTimeLineSectionImageUrl && <img src={data?.missionTimeLineSectionImageUrl} alt={data?.missionTimeLineSectionTitle ?? ""} className="max-h-64 w-full object-cover object-center rounded" />}
      </div>
    )
  };

  return (
    <div>
       <PreviewComponent />
    </div>
  )
}

export default TimelineItem